import PageHero from "../components/PageHero";

const STEPS = [
  {
    num: "01",
    icon: "ri-home-4-line",
    title: "Choose Your Villa Type",
    desc: "Select from five modular A-frame configurations — from a cozy 1-bedroom villa to a luxury duplex — based on your budget, goals and site.",
  },
  {
    num: "02",
    icon: "ri-file-list-3-line",
    title: "Reserve & Personalize",
    desc: "Secure your unit with a booking deposit and customize finishes, interiors and optional add-ons like solar, smart home or EV charging.",
  },
  {
    num: "03",
    icon: "ri-hammer-line",
    title: "Modular Construction & Delivery",
    desc: "Your villa is precision-built in our factory, transported to site and assembled — up to 60% faster than traditional construction with minimal disruption.",
  },
  {
    num: "04",
    icon: "ri-hotel-line",
    title: "Resort Launch & Management",
    desc: "Our hospitality team takes over — marketing, bookings, guest services and maintenance — so your villa starts generating income immediately.",
  },
  {
    num: "05",
    icon: "ri-money-cny-circle-line",
    title: "Earn Passive Income & Enjoy Stays",
    desc: "Receive recurring rental returns while retaining the freedom to use your villa for personal holidays whenever you choose.",
  },
];

export default function HowItWorks() {
  return (
    <div className="w-full">
      <PageHero
        eyebrow="How It Works"
        title={
          <>
            From Selection to <span className="italic text-accent-300">Income</span> in 5 Steps
          </>
        }
        subtitle="A transparent, guided process that takes you from choosing your villa to enjoying long-term returns and personal stays."
      />

      <section className="w-full py-12 md:py-16 bg-background-50">
        <div className="w-full px-4 md:px-8 max-w-5xl mx-auto">
          <div className="space-y-4">
            {STEPS.map((s) => (
              <div
                key={s.num}
                className="flex flex-col sm:flex-row gap-5 rounded-2xl bg-background-100 border border-background-200 p-6 hover:border-primary-300 transition-colors"
              >
                <div className="flex sm:flex-col items-center gap-4 sm:items-start sm:w-24 shrink-0">
                  <span className="flex items-center justify-center w-12 h-12 rounded-full bg-primary-600 text-background-50">
                    <i className={`${s.icon} text-xl`}></i>
                  </span>
                  <span className="font-heading text-3xl text-primary-200 font-bold">{s.num}</span>
                </div>
                <div className="pt-1">
                  <h3 className="font-heading text-xl text-foreground-950">{s.title}</h3>
                  <p className="text-sm text-foreground-600 mt-2 leading-relaxed">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <a
              href="/contact"
              className="inline-flex items-center gap-2 text-sm font-semibold whitespace-nowrap rounded-full bg-accent-500 text-background-50 px-7 py-3.5 hover:bg-accent-600 transition-colors"
            >
              Schedule Your Site Visit <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}